// extracted by mini-css-extract-plugin
module.exports = {"cloneStoryboard":"clone_cloneStoryboard__1p6vc","loading":"clone_loading__2fImh"};